import { render } from "./ConfigurarCertificado.vue?vue&type=template&id=1896f7f4&scoped=true"
import script from "./ConfigurarCertificado.vue?vue&type=script&lang=js"
export * from "./ConfigurarCertificado.vue?vue&type=script&lang=js"

import "./ConfigurarCertificado.vue?vue&type=style&index=0&id=1896f7f4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1896f7f4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QBtn,QCard,QImg,QEditor,QDialog,QCardSection});
